export const statusFilter: {
  [key in string]: {
    id: string
    status: string[] | string
  }
} = {
  all: {
    id: 'average_rating',
    status: [
      'writing_progress',
      'editing_progress',
      'fresh',
      'completed',
      'closed',
      'hold',
    ],
  },
  active: {
    id: 'on_time_submissions',
    status: ['writing_progress', 'editing_progress'],
  },
  completed: {
    id: 'average_approval_time',
    status: 'completed',
  },
  scrapped: {
    id: 'first_draft_approvals',
    status: 'scrapped',
  },
}
